// Utility functions for address handling

export const generateGoogleMapsLink = (address) => {
  // Encode the address for URL
  const encodedAddress = encodeURIComponent(address);
  return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
};

export const generateGoogleMapsDirections = (address) => {
  // Encode the address for directions URL
  const encodedAddress = encodeURIComponent(address);
  return `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`;
};

// Default clinic address
export const CLINIC_ADDRESS =
  "Shop No-6, Shopping Complex, Vasanth Nagar, IDPL Staff Cooperative Housing Society, Vasanth Nagar, Kukatpally, Hyderabad, Telangana 500085";

// Use the specific Google Maps link provided
export const CLINIC_GOOGLE_MAPS_LINK =
  "https://maps.app.goo.gl/T9QryBjHf1MDKznv7?g_st=aw";
export const CLINIC_GOOGLE_MAPS_DIRECTIONS =
  "https://maps.app.goo.gl/T9QryBjHf1MDKznv7?g_st=aw";
